export let messageRating = pageBootstrap => {
  const positiveRating = $('.thumb-up');
  const negativeRating = $('.thumb-down');
  negativeRatingHandler(negativeRating, pageBootstrap);
  positiveRatingHandler(positiveRating, pageBootstrap);
};

let feedbackTextAreaHandler = (messageId) => {
  const maxLimit = 500;
  let countField = document.getElementById("current-count-" + messageId);
  let feedbackDetails = document.getElementById("feedback-details-" + messageId);
  countField.innerText = maxLimit - feedbackDetails.value.length;
}

let negativeRatingHandler = (negativeRating, pageBootstrap) => {
  negativeRating.click(function() {
    let thumbDown = $(this);
    let ratingPath = thumbDown.parent().data('rating-path');
    let ratingVal = thumbDown.data('rating-value');
    let messageId = thumbDown.parent().data('message-id');

    thumbDown.children('i').addClass('thumb-down-selected');
    $('#thumb-up-' + messageId).children('i').removeClass('thumb-up-selected');
    feedbackBoxHandler(ratingPath, ratingVal, messageId, pageBootstrap);
  })
};

let positiveRatingHandler = (positiveRating, negativeRating, pageBootstrap) => {
  positiveRating.click(function() {
    let thumbUp = $(this);
    let ratingPath = thumbUp.parent().data('rating-path');
    let ratingVal = thumbUp.data('rating-value');
    let messageId = thumbUp.parent().data('message-id');

    thumbUp.children('i').addClass('thumb-up-selected');
    $('#thumb-down-' + messageId).children('i').removeClass('thumb-down-selected');

    feedbackBoxHandler(ratingPath, ratingVal, messageId, pageBootstrap);
  })
};

let feedbackBoxHandler = (ratingPath, ratingVal, messageId, pageBootstrap) => {
  document.querySelector('#message-feedback-' + messageId).scrollIntoView({
    behavior: 'smooth'
  });

  let detailsDiv = $('#message-feedback-details-' + messageId);
  detailsDiv.fadeIn('slow');

  let detailsContent = $('#feedback-details-' + messageId);
  detailsContent.keyup(function() {
    feedbackTextAreaHandler(messageId);
  });

  let detailsSubmit = $('#submit-feedback-' + messageId);
  detailsSubmit.off('click');
  detailsSubmit.click(function() {
    $.post(ratingPath, {rating: ratingVal, details: detailsContent.val()}, function () {
      detailsDiv.fadeOut('slow');
      pageBootstrap();
    })
  })
}
